import { setupMobX } from '../util/setupMobX';
import { action, makeObservable, observable, runInAction } from 'mobx';
import type { DispensariesResDto } from '@web/common';
import { getDispensaries } from '../request/authenticated-requests/dispensary';
import { handleRequestError } from '../request';

export class DispensaryStore {
  @observable public dispensaries: DispensariesResDto = [];
  @observable public loading: boolean = false;

  constructor() {
    makeObservable(this);
  }

  @action public loadDispensaries = () => {
    // Several components on the participant page ask for the dispensary list
    // independently. Skip the call if one is already in flight.
    if (this.loading) return;
    this.loading = true;

    getDispensaries()
      .then((dispensaries) =>
        runInAction(() => (this.dispensaries = dispensaries)),
      )
      .catch((error) => handleRequestError(error))
      .finally(() => runInAction(() => (this.loading = false)));
  };
}

const { provider, useStore } = setupMobX<DispensaryStore>();
export const useDispensaryStore = useStore;
export const DispensaryStoreProvider = provider;
